import React from 'react';
import Animation from '../Animation';
import './Rollup.scss';

export const Rollup : React.FC = Animation('rollup');

export default Rollup;
